import { message } from "src/components/Message";
import { DC } from "src/dataCollector/DataCollector";
import { utils } from "xlsx";


export async function danPantSkema(bfe_list: string[]) {

   message.progress("Henter data for ejendomme og hæftelser...");

   let Ejendomme: Record<string, any> = {};
   let hæftelser: Record<string, any> = {};

   for (let bfe of bfe_list) {
      let [
         tlData,
         adrData,
         mat,
         bbr
      ] = await Promise.all([
         DC.TL.EjendomTingbog(bfe),
         DC.DF_GQL.EBR.EBRAdresseOgPunkt(bfe),
         DC.DF_GQL.Mat2.BestemtFastEjendom(bfe),
         DC.DF_GQL.BBR.BBRRelation([bfe])
      ]);

      let ejendomsType = { "1": "Samlet fast ejendom", "2": "Bygning på fremmed grund", "3": "Ejerlejlighed" }[bbr.BBR_Ejendomsrelation?.nodes[0]?.ejendomstype || ""] || "Ukendt";
      let bebyggetAreal =
         bbr?.BBR_Ejendomsrelation?.nodes[0]?.grundSamletFastEjendom?.nodes?.[0]?.bygningGrund?.nodes?.[0]?.byg038SamletBygningsareal ||
         bbr?.BBR_Ejendomsrelation?.nodes[0]?.bygningEjerlejlighed?.nodes?.[0]?.byg038SamletBygningsareal ||
         bbr?.BBR_Ejendomsrelation?.nodes[0]?.ejendomsrelationBygningPaaFremmedGrund?.nodes?.[0]?.bygningBygningPaaFremmedGrund?.byg038SamletBygningsareal ||
         bbr?.BBR_Ejendomsrelation?.nodes[0]?.ejendomsrelationEjerlejlighed?.nodes?.[0]?.enhedEjerlejlighed?.enh026EnhedensSamledeAreal ||
         0;
      let bygnignsLøs = bebyggetAreal === 0 && ejendomsType == "Samlet fast ejendom" ? "Ja" : "Nej";

      tlData.hæftelser?.liste?.forEach((h) => {
         let id = h.aktAliasId || h.aktId;
         hæftelser[id] = {
            Pantebrev: h.senestPaategnetDato ? "Afgiftpantebrev" : h.haeftelsesType,
            RenteType: "", // Not available in data
            PålydendeSats: "", // Not available in data
            Kreditor: h.kreditor[0]?.legalUnitName || "", // Taking the first creditor's name if available
            Underpanthaver: "",
            Hovedstol: parseInt(h.beloebVaerdi.replace(".", "")) || 0,
            Valuta: h.valutakode,
            DatoLøbenummer: id,
            DokumentID: h.dokumentId, // not part of final
         };
      });

      let matrikler = mat.MAT_SamletFastEjendom?.nodes[0]?.jordstykkeSamlesISamletFastEjendom?.nodes?.map((js) => ({
         ejerlavskode: js.jordstykkeLiggerIEjerlav?.ejerlavskode || 0,
         ejerlavsnavn: js.jordstykkeLiggerIEjerlav?.ejerlavsnavn || "",
         matrikelnummer: js.matrikelnummer || "",
      }));

      let {
         streetName,
         buildingIdentifier,
         postCode,
         districtName,
         districtSubdivisionIdentifier
      } = tlData?.stamOplysninger?.adresse || {};

      let adkomstHaver = tlData.SenesteAdkomst?.adkomsthaver.toSorted((a, b) => a.andelProcent < b.andelProcent ? 1 : -1)?.map((a) => a.displayText) ?? [];


      Ejendomme[bfe] = {
         BFE: bfe,
         Adresse: (buildingIdentifier && streetName) ? (streetName + " " + buildingIdentifier + (districtSubdivisionIdentifier ? ", " + districtSubdivisionIdentifier : "")) : adrData[0]?.betegnelse || "Ukendt",
         PostnummerBy: (postCode || "") + " " + (districtName || "") || "",
         Adkomsthaver: adkomstHaver,// Taking the first adkomsthaver's name if available
         Bygningsløs: bygnignsLøs,
         Ejendomstype: ejendomsType,
         BygningsAreal: bebyggetAreal,
         Areal: mat.MAT_SamletFastEjendom?.nodes[0]?.jordstykkeSamlesISamletFastEjendom?.nodes?.reduce((sum, js) => sum + (js.registreretAreal || 0), 0) || 0,
         SenesteServitut: tlData?.servitutter?.toSorted((a, b) => a.tinglysningsDato > b.tinglysningsDato ? 1 : -1).map((a) => a.aktAliasId || a.aktId)?.[0] || null,
         hæftelser: tlData.hæftelser?.liste?.map((h) => h.aktAliasId || h.aktId) || [],
         Ejerlav: matrikler?.[0]?.ejerlavsnavn || "", // Taking the first matrikel's ejerlavsnavn if available
         Matriklen: matrikler?.map((js) => js.matrikelnummer).join(", ") || "",
      }
   }

   let totalHæftelser = Object.keys(hæftelser).length;
   message.progress("Henter detaljer for " + totalHæftelser + " hæftelser...");

   let i = 0;
   for (let key in hæftelser) {
      let TLXml = await DC.TL.DokumentTingbog(hæftelser[key].DokumentID)

      let HaeftelseStruktur = TLXml.getElementsByTagName("HaeftelseStruktur")[0];

      hæftelser[key].RenteType =
         HaeftelseStruktur?.getElementsByTagName("HaeftelseRenteVariabel")?.[0]?.textContent ? "Variabel"
            : HaeftelseStruktur?.getElementsByTagName("HaeftelseRenteFast")?.[0]?.textContent ? "Fast"
               : "";
      hæftelser[key].PålydendeSats = HaeftelseStruktur?.getElementsByTagName("HaeftelseRentePaalydendeSats")?.[0]?.textContent || "";

      let underpantSamling = HaeftelseStruktur?.getElementsByTagName("UnderpanthaverInformationSamling")?.[0];
      if (underpantSamling) {
         let LegalUnitName = underpantSamling.getElementsByTagName("LegalUnitName")?.[0]?.textContent || "";
         let CVRnumberIdentifier = underpantSamling.getElementsByTagName("CVRnumberIdentifier")?.[0]?.textContent || "";
         let underpanthaver = LegalUnitName || CVRnumberIdentifier ? `${LegalUnitName ?? ""} ${CVRnumberIdentifier ?? ""}`.trim() : "";
         hæftelser[key].Underpanthaver = underpanthaver;
      }
      i++;
      message.progress("Henter detaljer for " + totalHæftelser + " hæftelser...", Math.round((i / totalHæftelser) * 100));
   }

   let aoa = aoaFromHæftelserOgEjendomme(Ejendomme, hæftelser)
   let sheet = utils.aoa_to_sheet(aoa);

   sheet["!cols"] = aoa[0].map((_, i) => ({ wch: Math.min(30, Math.max(...aoa.map(r => (r[i] ? r[i].toString().length : 0)))) || 10 }));

   let book = utils.book_new(sheet, "Skema");

   let ejnData = Object.values(Ejendomme)
   let ejn = utils.json_to_sheet(ejnData.map((a) => ({ ...a, Hæftelser: a.hæftelser.join(", "), Adkomsthaver: a.Adkomsthaver.join(", ") })));
   ejn["!cols"] = Object.keys(ejnData[0] || {}).map((a) => ({ wch: Math.max(...ejnData.map(r => (r[a] ? r[a].toString().length : 0))) || 10 }));
   utils.book_append_sheet(book, ejn, "Ejendomme");
   let hæfData = Object.values(hæftelser)
   let hæf = utils.json_to_sheet(hæfData);
   hæf["!cols"] = Object.keys(hæfData[0] || {}).map((a) => ({ wch: Math.max(...hæfData.map(r => (r[a] ? r[a].toString().length : 0))) || 10 }));
   utils.book_append_sheet(book, hæf, "Hæftelser");


   return book;
}

function aoaFromHæftelserOgEjendomme(Ejendomme: Record<string, any>, hæftelser: Record<string, any>): any[][] {

   let datoFormated = new Date().toLocaleDateString("da-DK", { day: "2-digit", month: "2-digit", year: "2-digit" });
   let DateHeader = "Dato: " + datoFormated;

   let mostAdkomsthaver: number = Object.values(Ejendomme).reduce((max, ej) => {
      if (ej.Adkomsthaver.length > max) {
         return ej.Adkomsthaver.length;
      } return max;
   }, 0) ?? 0;

   let AdkomsthaverHeader = ["Adkomsthaver"];
   if (mostAdkomsthaver) {
      AdkomsthaverHeader = new Array(mostAdkomsthaver).fill("").map((_, e) => "Adkomsthaver " + (e + 1));
   }

   let verticalHeaders = [DateHeader, ...AdkomsthaverHeader, "Adresse", "Postnummer, by", "BFE-nummer", "Grundareal ha", "Samlet bygningsareal m2", "Bygningsløs", "Ejendomstype", "Ejerlavsnavn", "Antal Matrikler", "Seneste servitut"];
   let horizontalHeaders = ["Pantebrev", "Rentetype", "Pålydende rentesats", "Kreditor", "Underpanthaver", "Hovedstol", "Valuta", "Dato/Løbenummer"]

   let cols = horizontalHeaders.length + Object.keys(Ejendomme).length + 1;
   let rows = verticalHeaders.length + Object.keys(hæftelser).length + 2;

   let dataRows: any[][] = Array.from({ length: rows }, () => Array(cols).fill(""));
   verticalHeaders.forEach((header, index) => {
      dataRows[index][0] = header;
   })

   horizontalHeaders.forEach((header, index) => {
      dataRows[verticalHeaders.length + 1][index] = header;
   })

   let hæftelsesOrder = Object.keys(hæftelser).toSorted((a, b) => {
      if (hæftelser[a].Pantebrev === hæftelser[b].Pantebrev) {
         return a > b ? 1 : -1;
      }
      if (hæftelser[a].Pantebrev === "Afgiftpantebrev") {
         return 1;
      }
      if (hæftelser[b].Pantebrev === "Afgiftpantebrev") {
         return -1;
      }
      return hæftelser[b].Pantebrev > hæftelser[a].Pantebrev ? 1 : -1;
   });

   hæftelsesOrder.forEach((key, index) => {
      let h = hæftelser[key];
      let colIndex = 0;
      dataRows[verticalHeaders.length + 2 + index][colIndex] = h.Pantebrev;
      dataRows[verticalHeaders.length + 2 + index][colIndex + 1] = h.RenteType;
      dataRows[verticalHeaders.length + 2 + index][colIndex + 2] = h.PålydendeSats ? parseFloat(h.PålydendeSats).toLocaleString("da-DK") + " %" : "";
      dataRows[verticalHeaders.length + 2 + index][colIndex + 3] = h.Kreditor;
      dataRows[verticalHeaders.length + 2 + index][colIndex + 4] = h.Underpanthaver || " ";
      dataRows[verticalHeaders.length + 2 + index][colIndex + 5] = h.Hovedstol;
      dataRows[verticalHeaders.length + 2 + index][colIndex + 6] = h.Valuta;
      dataRows[verticalHeaders.length + 2 + index][colIndex + 7] = h.DatoLøbenummer;
   })

   Object.values(Ejendomme).forEach?.((ejendom, index) => {
      let rowIndex = index + horizontalHeaders.length + 1;
      ejendom.Adkomsthaver.forEach?.((adkomsthaver: string, aIndex: number) => {
         dataRows[0 + 1 + aIndex][rowIndex] = adkomsthaver;
      });
      dataRows[1 + mostAdkomsthaver][rowIndex] = ejendom.Adresse;
      dataRows[2 + mostAdkomsthaver][rowIndex] = ejendom.PostnummerBy;
      dataRows[3 + mostAdkomsthaver][rowIndex] = ejendom.BFE;
      dataRows[4 + mostAdkomsthaver][rowIndex] = ejendom.Areal / 10000; // Convert m2 to ha
      dataRows[5 + mostAdkomsthaver][rowIndex] = ejendom.BygningsAreal || " ";
      dataRows[6 + mostAdkomsthaver][rowIndex] = ejendom.Bygningsløs || " ";
      dataRows[7 + mostAdkomsthaver][rowIndex] = ejendom.Ejendomstype || " ";
      dataRows[8 + mostAdkomsthaver][rowIndex] = ejendom.Ejerlav;
      dataRows[9 + mostAdkomsthaver][rowIndex] = ejendom.Matriklen.split(", ").length;
      dataRows[10 + mostAdkomsthaver][rowIndex] = ejendom.SenesteServitut;

      ejendom.hæftelser?.forEach?.((hId: string) => {
         let hæftelseID = hæftelsesOrder.indexOf(hId);
         if (hæftelseID !== -1) {
            let hæftelseRowIndex = verticalHeaders.length + 2 + hæftelseID
            dataRows[hæftelseRowIndex][rowIndex] = hæftelser[hæftelsesOrder[hæftelseID]]?.Hovedstol || "";
         }
      })
   })

   return dataRows;

}